import InventorySerialized from "./InventorySerialized";

export default InventorySerialized;